


















































import Vue from 'vue'
import { getSlideCursor } from '@/utils/getSlideCursor'
import 'vue-awesome/icons/forward'
import 'vue-awesome/icons/backward'
const { default: Icon } = require('vue-awesome/components/Icon')

export default Vue.extend({
  components: {
    'v-icon': Icon
  },
  props: {
    disable: Boolean,
    pages: Array as () => string[],
    page: Number,
    option: Object
  },
  methods: {
    handleClickProgress(event: MouseEvent) {
      const progress = this.$refs.progress! as HTMLElement
      const clientX = event.clientX - progress.getBoundingClientRect().left
      const p = Math.min(
        this.pages.length,
        getSlideCursor(this.pages.length, progress.clientWidth, clientX) - 1
      )
      this.$emit('move', p)
    }
  }
})
